import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  leading?: ReactNode;
  className?: string;
  as?: 'h1' | 'h2';
}

export function PageHeader({ title, subtitle, actions, leading, className, as = 'h1' }: PageHeaderProps) {
  const Heading = as;
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="flex items-start gap-3 min-w-0 flex-1">
        {leading}
        <div className="min-w-0">
          {/* break-words statt truncate (Task 12): jeder Titel hier ist ein
              i18n-Label, keine dynamische Produktdaten-Zeichenkette - eine
              Ellipse verschluckt Bedeutung, ohne dafuer Platz zu sparen.
              Bei 375px reichte der Bedarf mancher Titel (z.B. PerformanceDashboard)
              den verfuegbaren Platz um das Doppelte, truncate schnitt mitten im Wort. */}
          <Heading className="break-words">{title}</Heading>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
